module.exports = __webpack_public_path__ + "img/icon-arrow-right.7a4e074b.svg";